import ContractsPublicService from "@/domains/Contracts/ContractsPublicService";
import type ContractPublic from "@/domains/Contracts/ContractPublic";

// ВАЖНО: предыдущий коммит содержит версию LoginForm с привязкой к версиям договоров.
// если версия договора изменилась, то галочки на чекбоксе не будет

/** Модель формы страницы логина.
 * Общая для всех вьюх — каждая использует свой набор полей */
export default class LoginForm {
  email: string;
  password: string;
  code: string;
  phone: string;
  name: string;

  /** Флаги акцепта — по одному на каждый публичный договор */
  userAgreement: boolean = false;
  permissionForProcessing: boolean = false;
  userConfidential: boolean = false;

  constructor() {
    this.restoreAgreementFlags();
  }

  /** Все ли публичные договоры акцептованы галочками на форме */
  get allAgreementsAccepted(): boolean {
    return this.userAgreement
      && this.permissionForProcessing
      && this.userConfidential;
  }

  /** Восстанавливает акцепт флагов из общего стора акцептов,
   * чтобы не заставлять пользователя проставлять галочки при каждом входе */
  restoreAgreementFlags(): this {
    this.userAgreement           = ContractsPublicService.isTypeAccepted('userAgreement');
    this.permissionForProcessing = ContractsPublicService.isTypeAccepted('permissionForProcessing');
    this.userConfidential        = ContractsPublicService.isTypeAccepted('userConfidential');

    return this;
  }

  /** Запоминает акцептованные договоры,
   * чтобы восстановить флаги при следующем входе */
  saveAgreementFlagsToLocalStorage() {
    ContractsPublicService.putContractIntoLocalStorage(this.getAcceptedContractTypes());
  }

  /** Возвращает список типов договоров, подтверждённых флагами на форме */
  getAcceptedContractTypes(): string[] {
    const types: string[] = [];

    if (this.userAgreement) {
      types.push('userAgreement');
    }

    if (this.permissionForProcessing) {
      types.push('permissionForProcessing');
    }

    if (this.userConfidential) {
      types.push('userConfidential');
    }

    return types;
  }

  /** Возвращает актуальные версии договоров, подтверждённых флагами на форме.
   * Бек акцептует конкретную версию, поэтому версии запрашиваются
   * в момент акцепта — форма их не хранит */
  async getAcceptedContracts(): Promise<ContractPublic[]> {
    const contracts: ContractPublic[] = [];

    for (const type of this.getAcceptedContractTypes()) {
      contracts.push(await ContractsPublicService.getActualContract(type));
    }

    return contracts;
  }
}
